import ServicesFeaturedServices from './ServicesFeaturedServices';

export { type ServicesFeaturedServicesProps } from './ServicesFeaturedServices';
export default ServicesFeaturedServices;
